import type { PartnerPromoCode } from '@backmarket/front-office/api/partner-promo-code/types'

import type { Price } from '../../api-models'
import { MarketCountryCode } from '../../api-models/MarketCountryCode'
import type { MobilePlanOffer } from '../../api-specs-b2c-services/mobile-plan/types/mobile-plan-offers'
import { type HttpResponsePayload, createHttpEndpoint } from '../../utils'

// Deprecated to remove in B2CS-533
export type ServiceOffer = {
  id: string
  serviceType: string
  partnerName: string
}

/**
 * @see {@link https://devportal.backmarket.io/catalog/default/api/product-page-service-api/definition#/product-page/get_product}
 */
export const getProduct = createHttpEndpoint<GetProductResponse>({
  method: 'GET',
  operationId: 'getProduct',
  path: '/product-page/products/:productId',
})

export type PromoCode = {
  token: string
  isFlashSale?: boolean
  discountValue: Price
}

export type GetProductResponse = HttpResponsePayload<{
  supportsAppleIntelligence: boolean
  productLegacyId: number
  productId: string
  type: 'Refurbished' | 'Brand new' | 'Digital'
  titles: {
    raw: string
    default: string
    // not available in products without a parent product
    subtitle?: string
  }
  subtitleElements: Array<string>
  priceWhenNew: Price
  isTradeInEligible: boolean
  images: Array<{
    url: string
    description: string
    source?: 'CATALOG' | 'PARTNER'
  }>
  brand: string
  model: string | undefined
  carrier: {
    isDisplayed: boolean
    locked: boolean
    name: 'Verizon' | 'AT&T' | 'T-Mobile' | string | null
  }
  comesWith: {
    displayAccessoryExclusionsModal: boolean
    items: Array<{
      icon: string
      text: string
      type: string
    }>
  }
  parentProductSlug?: string | null
  tracking: {
    categoryId: string
    categoryName: string
    color: string
  }
  scores: { id: string; label: string; value: string }[]
  seo: {
    slug: string
    description: string
    marketsLinks: Array<{ countryCode: MarketCountryCode; slug: string }>
  }
  isProductRematched: boolean
  showVerifiedRefurbished: boolean
  showObsoleteDevices: boolean
  includedServiceOffers: {
    mobilePlans: Array<MobilePlanOffer>
    partnerPromoCodes: Array<PartnerPromoCode>
  }
  promoCodes: PromoCode[]
  dualSim: string
  instructions: string | null
  hasDeals: boolean
}>
